import { selectShowKbSearchOnInboxEditor } from 'ducks/currentUser/selectors'
import { doUpdateUserPreferences } from 'ducks/currentUser/operations'

export function doToggleShowKbSearchOnInboxEditor() {
  return (dispatch, getState) => {
    const state = getState()
    const showKbSearchOnInboxEditor = selectShowKbSearchOnInboxEditor(state)
    return doUpdateUserPreferences({
      show_kb_search_on_inbox_editor: !showKbSearchOnInboxEditor,
    })(dispatch, getState)
  }
}
